import {Decoder, equal, oneOf} from 'json-bouncer'

export type ProductCategory =
    | 'Stock'
    | 'VdpProject'
    | 'Special'
    | 'VdpTemplate'
    | 'Pod'
    | 'Download'
    | 'Calculation'
    | 'BulkTemplate'
    | 'BulkProject'
    | 'Postage'
    | 'Preorder'
    | 'TypesetRequest'

export function decoder(): Decoder<ProductCategory> {
    const
        stock: ProductCategory = 'Stock',
        vdpProject: ProductCategory = 'VdpProject',
        special: ProductCategory = 'Special',
        vdpTemplate: ProductCategory = 'VdpTemplate',
        pod: ProductCategory = 'Pod',
        download: ProductCategory = 'Download',
        calculation: ProductCategory = 'Calculation',
        bulkTemplate: ProductCategory = 'BulkTemplate',
        bulkProject: ProductCategory = 'BulkProject',
        postage: ProductCategory = 'Postage',
        preorder: ProductCategory = 'Preorder',
        typesetRequest: ProductCategory = 'TypesetRequest'
    return oneOf([
        equal(stock),
        equal(vdpProject),
        equal(special),
        equal(vdpTemplate),
        equal(pod),
        equal(download),
        equal(calculation),
        equal(bulkTemplate),
        equal(bulkProject),
        equal(postage),
        equal(preorder),
        equal(typesetRequest),
    ])
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/ProductCategory.ts